import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError, mergeMap, take, takeUntil } from 'rxjs/operators';
import { Subject, forkJoin, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from 'app/auth/service';
import { CikktorzsService } from '../../torzsek/services/cikktorzs.service';
import { DolgozokService } from '../../torzsek/services/dolgozok.service';
import { PartnerekService } from '../../torzsek/services/partnerek.service';
import { OrszagokService } from '../../torzsek/services/orszagok.service';
import { PenzintezetekService } from '../../torzsek/services/penzintezetek.service';
import { MegyekService } from '../../torzsek/services/megyek.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-auth-login-munkatars',
  templateUrl: './auth-login-munkatars.component.html',
  styleUrls: ['./auth-login-munkatars.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AuthLoginMunkatarsComponent implements OnInit {
  //  Public
  public coreConfig: any;
  public loginForm: FormGroup;
  public jelszoForm: FormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  public passwordTextType: boolean;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private authService: AuthenticationService,
    private dolgozokService: DolgozokService,
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private partnerekService: PartnerekService,
    private ngb: NgbModal
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  get formValue(): { adoszam: string } {
    return this.loginForm.getRawValue();
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  onSubmit(modalRef: any) {
    this.submitted = true;
    
    //this.ngb.open(modalRef, { centered: true });
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    // Login
    this.loading = true;

    this.authService
      .login_2(this.formValue.adoszam)
      .pipe(
        take(1),
        catchError((err) => {
          this.loading = false;
          console.log(err);

          return throwError(err);
        })
      )
      .subscribe((resp) => {
        // this.returnUrl
        //   ? this._router.navigateByUrl(this.returnUrl)
        //   : this._router.navigate(['/']);
      if(resp) {
          const allApiCalls = [
            this.partnerekService.initData$.pipe(take(1)),
            this.dolgozokService.fetchData().pipe(take(1)),
          ];

          const numberOfSimultaneousRequests = 1;

          forkJoin(
            of(...allApiCalls)
           .pipe(
            mergeMap((apiCall) => apiCall, numberOfSimultaneousRequests),
          )
          ).subscribe(resp => {
            if(resp) {
              this._router.navigate(['/torzsek/szabadsag-naptar']);
              //this.loading = false;
            }
          })
        }
      }
    );
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.authService.logout();
    this.loginForm = this._formBuilder.group({
      adoszam: [null, Validators.required],
    });

    this.jelszoForm = this._formBuilder.group({
      jelszo: [null, Validators.required],
      jelszo_2: [null, Validators.required],
    });


    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';

    // Subscribe to config changes
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.coreConfig = config;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
